import { Module } from 'vuex'
import { SchoolState, RootState } from '../types'

export const store: Module<SchoolState, RootState> = { }
